import { Pipe, PipeTransform } from '@angular/core';
import { PlanwertType } from '../../domain/model/planwert-type.enum';

@Pipe({
    name: 'planwertType',
    standalone: false,
})
export class PlanwertTypePipe implements PipeTransform {

    transform(value: PlanwertType): string {
        switch (value) {
            case PlanwertType.BRUTTONENNLEISTUNG:
                return 'Bruttonennleistung';
            case PlanwertType.SR_ID:
                return 'SR-ID';
            case PlanwertType.SG_ID:
                return 'SG-ID';
            case PlanwertType.ANLAGENBETREIBER_NAME:
                return 'Anlagenbetreiber Name';
            case PlanwertType.ANLAGENBETREIBER_STRASSE:
                return 'Anlagenbetreiber Str.';
            case PlanwertType.ANLAGENBETREIBER_HAUSNUMMER:
                return 'Anlagenbetreiber Hausnummer';
            case PlanwertType.ANLAGENBETREIBER_HAUSNUMMER_ZUSATZ:
                return 'Anlagenbetreiber Hausnummerzusatz';
            case PlanwertType.ANLAGENBETREIBER_PLZ:
                return 'Anlagenbetreiber PLZ';
            case PlanwertType.ANLAGENBETREIBER_ORT:
                return 'Anlagenbetreiber Ort';
            case PlanwertType.MARKTLOKATION:
                return 'Marktlokation';
            case PlanwertType.BILANZKREIS:
                return 'Identifikator des Bilanzkreis';
            case PlanwertType.LIEFERANT_MARKTLOKATION:
                return 'Lieferant-Marktlokation';
            case PlanwertType.TRANCHE_MARKTLOKATION:
                return 'Marktlokation Tranche';
            case PlanwertType.TRANCHE_BILANZKREIS:
                return 'Bilanzkreis Tranche';
            case PlanwertType.TRANCHE_LIEFERANT:
                return 'Lieferant Tranche';
            case PlanwertType.TRANCHE_GROESSE:
                return 'Tranchengröße [%]';
        }
        return value;
    }
}
